import React, { useMemo } from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

interface Props {
  isOpen: boolean;
  businessName: string;
  feesEnabledOnBusiness: boolean;
  pendingMerchantFeeValue: boolean | null;
  handleClose: () => void;
  handleConfirm: () => void;
}

export default function MerchantFeeOverrideConfirmDialog({
  isOpen,
  businessName,
  feesEnabledOnBusiness,
  pendingMerchantFeeValue,
  handleClose,
  handleConfirm,
}: Props) {
  const message = useMemo(() => {
    if (pendingMerchantFeeValue == null) {
      return '';
    }
    const name = businessName.trim() || 'This business';
    const feesStateLabel = feesEnabledOnBusiness ? 'enabled' : 'disabled';
    const actionVerb = pendingMerchantFeeValue ? 'enable' : 'disable';
    return `${name} has merchant fees ${feesStateLabel}, are you sure you want to ${actionVerb} merchant fees?`;
  }, [businessName, feesEnabledOnBusiness, pendingMerchantFeeValue]);

  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <DialogTitle>Merchant fees</DialogTitle>
      {message ? <DialogContent>{message}</DialogContent> : null}
      <DialogActions>
        <Button variant="text" onClick={handleClose} data-testid="merchant-fee-confirm-no">
          No
        </Button>
        <Button variant="contained" color="primary" onClick={handleConfirm} data-testid="merchant-fee-confirm-yes">
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}
